/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: Work on better types and implementation to avoid any

export function isEqual(x: any, y: any, seen: WeakSet<object> = new WeakSet()): boolean {
    if (x === y) {
        return true;
    }
    if (typeof x !== "object" || x === null || typeof y !== "object" || y === null) {
        return false;
    }

    if (x instanceof Date && y instanceof Date) {
        return x.getTime() === y.getTime();
    }

    if (seen.has(x) || seen.has(y)) {
        console.warn("Circular reference detected in isEqual");
        return false;
    }
    seen.add(x);
    seen.add(y);

    const xKeys = Object.keys(x);
    // Same key count is not enough: `{a: undefined}` must not equal `{b: 1}`.
    return xKeys.length === Object.keys(y).length && xKeys.every((key) => Object.prototype.hasOwnProperty.call(y, key) && isEqual(x[key], y[key], seen));
}
/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: Work on better types and implementation to avoid any

export function isEqual(x: any, y: any, seen: WeakSet<object> = new WeakSet()): boolean {
    if (x === y) {
        return true;
    }
    if (typeof x !== "object" || x === null || typeof y !== "object" || y === null) {
        return false;
    }

    if (x instanceof Date && y instanceof Date) {
        return x.getTime() === y.getTime();
    }

    if (seen.has(x) || seen.has(y)) {
        console.warn("Circular reference detected in isEqual");
        return false;
    }
    seen.add(x);
    seen.add(y);

    const xKeys = Object.keys(x);
    // Same key count is not enough: `{a: undefined}` must not equal `{b: 1}`.
    return xKeys.length === Object.keys(y).length && xKeys.every((key) => Object.prototype.hasOwnProperty.call(y, key) && isEqual(x[key], y[key], seen));
}
